import type { ListItemProps, ListProps, SystemProps } from '@chakra-ui/react';
import { Link, List, ListItem } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { menuItems } from '../constants';

interface IMenuProps {
  activeStyle?: SystemProps;
  children?: React.ReactNode;
  linkProps?: SystemProps;
  listItemProps?: ListItemProps;
  listProps?: ListProps;
  onItemClick?: () => void;
}

export const Menu: React.FC<IMenuProps> = ({
  activeStyle,
  children,
  linkProps = {},
  listItemProps = {},
  listProps = {},
  onItemClick,
}): JSX.Element => {
  const { t } = useTranslation();

  const handleNavClick = (): void => {
    onItemClick?.();
  };

  return (
    <List as="nav" {...listProps}>
      {menuItems.map((item) => (
        <ListItem key={`menuItem-${item.id}`} {...listItemProps}>
          <NavLink to={item.href}>
            {({ isActive }): JSX.Element => (
              <Link
                _hover={{ cursor: 'pointer' }}
                as="span"
                display="block"
                fontSize="large"
                fontWeight="medium"
                lineHeight="normal"
                paddingInlineEnd={0}
                paddingInlineStart={0}
                onClick={handleNavClick}
                {...linkProps}
                {...(isActive && activeStyle)}
              >
                {t(item.label)}
              </Link>
            )}
          </NavLink>
        </ListItem>
      ))}
      {children}
    </List>
  );
};
